export default __webpack_public_path__ + "static/media/avatar_0.2960d398.png";